import React, {useEffect, useState} from "react";
import { useSearchParams, useNavigate } from 'react-router-dom';


import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
// import HeaderOne from "../../components/layout/HeaderOne";
import HeaderHome from "../../components/layout/HeaderHome";
import Breadcrumb from "../../components/seller-store/Breadcrumb";
// import BreadcrumbImage from "../../components/BreadcrumbImage";
import StoreHeaderImage from "../../components/seller-store/StoreHeaderImage";
import CategoryNav from "../../components/seller-store/CategoryNav";
import RecommendedProducts from "../../components/seller-store/RecommendedProducts";
import ProfileStore from "../../components/seller-store/ProfileStore";
import StoreProducts from "../../components/seller-store/StoreProducts";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";



const SellerStorePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [companyID, setCompanyID]=useState("");

  const config = JSON.parse(
                localStorage.getItem("user")
            );

    useEffect(() => {
      // Check if the specific query parameter is missing
      if (!searchParams.has('storeid')) {
        // Redirect the user to another page (e.g., the homepage or an error page)
        //navigate('/', { replace: true }); // Using replace: true prevents the original page from being in the browser history
        setCompanyID(config.companyId);

      }else{
         setCompanyID(searchParams.get('storeid'));
      }
    }, [searchParams, navigate]); // Depend on searchParams and navigate

    useEffect(()=>{

      console.log("companyID", companyID)
    })
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#990A02' />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      {/* <HeaderOne /> */}
      <HeaderHome />

      {/* Breadcrumb */}
      <Breadcrumb title={'Store'} />


      <StoreHeaderImage storeId={companyID} />

      <CategoryNav />

        <RecommendedProducts />

        <ProfileStore storeId={companyID}/>

        <StoreProducts />

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default SellerStorePage;